import { verifyReferralToken } from '@/widgets/action'

class ReferralEventData {
  referralParams: any = null

  async getReferralEventData() {
    if (!this.referralParams) {
      const token = new URLSearchParams(window.location.search).get('token')
      if (token) {
        const response = await verifyReferralToken()
        this.referralParams = {
          referral_mlp: response?.referralCode ? 'y' : 'n',
          referrer_code: response?.referralCode || '',
          referrer_name: localStorage.getItem('referralUser') || '',
        }
      }
    }
    return this.referralParams
  }
}

export const ReferralEventDataObj = new ReferralEventData()
